var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "text-2xl text-default-400 pointer-events-none",
    width: "1em",
    height: "1em",
    "aria-hidden": "true",
    focusable: "false",
    role: "presentation",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.25 9.1497c-2.31-3.63-5.69-5.72-9.25-5.72-1.78 0-3.51 0.52-5.09 1.49-1.58 0.98-3 2.41-4.16 4.23-1 1.57-1 4.12 0 5.69 2.31 3.64 5.69 5.72 9.25 5.72 1.78 0 3.51-0.52 5.09-1.49 1.58-0.98 3-2.41 4.16-4.23 1-1.56 1-4.12 0-5.69zm-9.25 6.89c-2.24 0-4.04-1.81-4.04-4.04 0-2.23 1.8-4.04 4.04-4.04s4.04 1.81 4.04 4.04c0 2.23-1.8 4.04-4.04 4.04z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11.998 9.1406c-1.57 0-2.85 1.28-2.85 2.86 0 1.57 1.28 2.85 2.85 2.85s2.86-1.28 2.86-2.85-1.29-2.86-2.86-2.86z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeShow);
export default __webpack_public_path__ + "static/media/eye_show.6a4211b20f0f2635235bf255ff580574.svg";
export { ForwardRef as ReactComponent };